import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ScrollableSource, Tooltip, useFormSelector } from '@eas/common-web';

export const useStyles = makeStyles(() => ({
  label: {
    fontWeight: 600,
  },
}));

export function FormTableCount<T>({
  source,
  formKey,
  items = [],
}: {
  source?: ScrollableSource<T>;
  formKey?: string;
  items?: T[];
}) {
  const classes = useStyles();

  const { formItems } = useFormSelector((values: Record<string, []>) => ({
    formItems: values?.[formKey ?? ''] ?? [],
  }));

  let label = `[ ${items.length} ]`;
  if (source) {
    const min = Math.min(source?.items?.length ?? 0, source.count);
    label = `[ ${min} / ${source.count} ]`;
  }
  if (formKey) {
    label = `[ ${formItems.length} ]`;
  }

  return (
    <Tooltip
      title={
        <FormattedMessage
          id="ES__FORM_TABLE_COUNT"
          defaultMessage="Načteno / Celkový počet záznamů"
        />
      }
    >
      <Typography variant="body1" display="inline" className={classes.label}>
        {label}
      </Typography>
    </Tooltip>
  );
}
